import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {StandingLoadOrderService} from 'app/blocks/service/api/standing-load-order.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IStandingOrder} from 'app/blocks/model/standing-order.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {StandingOrder} from 'app/blocks/model/standing-order.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class StandingLoadOrderResource extends AbstractEntityResource<IStandingOrder> {
    constructor(standingLoadOrderService: StandingLoadOrderService, router: Router) {
        super(
            Resource.STANDING_LOAD_ORDERS,
            standingLoadOrderService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.STANDING_LOAD_ORDERS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.STANDING_LOAD_ORDERS),
            (entity?) => new StandingOrder(entity),
            (entity) => entity.id,
            'file_copy'
        );
    }
}
